/**
 * Only these users may delete inventory from Add Inventory.
 * Same IDs as elite users in isAbleToModifyBooking (Aksha, Vanshita, Darshan).
 */
const DELETE_INVENTORY_USER_IDS = [
  "6655d9b40777525410c88982",
  "651bd4c8ad7773279c5ae380",
  "6746d54f4d93e350eadae03f",
];

export default function canDeleteInventory(userId) {
  if (!userId) return false;
  return DELETE_INVENTORY_USER_IDS.includes(String(userId));
}
